import React from 'react'
import { TfiGithub } from 'react-icons/tfi'
import './Components.css'



const CardHeader = ({ title, subtitle, link }) => {
  return (
    <div>
      <div className='cardheader'>
        <div className='cardtitle'>
          <h2>{title}</h2>
        </div>
        <div className='githubicon'>
          <a
            href={link}
            title='View repository on Github'
          >
            <TfiGithub />
          </a>
        </div>
      </div>
      <div className='cardsubtitle'>
        <p>{subtitle}</p>
      </div>
    </div>
  )
}

export default CardHeader